import getLocalString from "constants/Localization";
import { useCustomDuplicateProposalMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDuplicateProposal() {
  const [mutation, { loading, data, error }] = useCustomDuplicateProposalMutation();
  const [duplicateProposal, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "duplicateProposal",
    },
    {
      successMessage: getLocalString("proposals.duplicate-proposal-success"),
      failureMessage: getLocalString("proposals.duplicate-proposal-failure"),
      showValidationErrors: true,
    }
  );

  return [duplicateProposal, context] as const;
}
